export default __webpack_public_path__ + "static/media/great.d96f396c.svg";